(function () {
  const PROBO_DATE_GUARD = {
    timeZone: "Europe/Berlin",
    warningId: "probo-date-guard-warning",
    message:
      "Der gewählte Versandtermin ist leider nicht mehr verfügbar. Bitte entfernen Sie den betroffenen Artikel aus dem Warenkorb und legen Sie ihn anschließend erneut mit einem aktuellen Versandtermin in den Warenkorb.",
    testAlwaysBlock: false
  };

  function getShopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function getTodayInBerlin() {
    const parts = new Intl.DateTimeFormat("de-DE", {
      timeZone: PROBO_DATE_GUARD.timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());

    const map = {};

    parts.forEach(part => {
      map[part.type] = part.value;
    });

    return `${map.year}-${map.month}-${map.day}`;
  }

  function getDatePart(value) {
    if (!value) return null;

    const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : null;
  }

  function getDateInBerlinFromTimestamp(value) {
    if (!value) return null;

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return null;
    }

    const parts = new Intl.DateTimeFormat("de-DE", {
      timeZone: PROBO_DATE_GUARD.timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(date);

    const map = {};

    parts.forEach(part => {
      map[part.type] = part.value;
    });

    return `${map.year}-${map.month}-${map.day}`;
  }

  function isProboLineItem(item) {
    const properties = item.properties || {};

    return Boolean(
      properties._probo_config ||
      properties._shipping_date ||
      properties._delivery_date ||
      properties._probo_timestamp
    );
  }

  function getInvalidProboItems(cart) {
    const today = getTodayInBerlin();

    return (cart.items || [])
      .filter(isProboLineItem)
      .map(item => {
        const properties = item.properties || {};

        const shippingDate = getDatePart(properties._shipping_date);
        const timestampDate = getDateInBerlinFromTimestamp(
          properties._probo_timestamp
        );

        return {
          item,
          shippingDate,
          timestampDate,
          timestamp: properties._probo_timestamp || null
        };
      })
      .filter(entry => {
        if (PROBO_DATE_GUARD.testAlwaysBlock) {
          return true;
        }

        /*
          Regel 1:
          Wenn der Artikel an einem früheren Kalendertag in den Warenkorb gelegt wurde,
          muss er neu konfiguriert werden.

          Beispiel:
          Gestern konfiguriert / in den Warenkorb gelegt
          Heute Checkout
          → blockieren
        */
        if (entry.timestampDate && entry.timestampDate < today) {
          return true;
        }

        /*
          Regel 2:
          Versanddatum heute oder Vergangenheit blockieren.

          Beispiel:
          Heute ist 2026-06-18
          Versanddatum ist 2026-06-18 oder älter
          → blockieren
        */
        if (entry.shippingDate && entry.shippingDate <= today) {
          return true;
        }

        return false;
      });
  }

  async function fetchCart() {
    const response = await fetch(`${getShopRoot()}cart.js`, {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Warenkorb konnte nicht geprüft werden.");
    }

    return response.json();
  }

  function removeExistingWarning() {
    const oldWarning = document.getElementById(PROBO_DATE_GUARD.warningId);

    if (oldWarning) {
      oldWarning.remove();
    }
  }

  function showWarning(invalidItems) {
    removeExistingWarning();

    const productNames = invalidItems
      .map(entry => entry.item.product_title || entry.item.title)
      .filter(Boolean)
      .join(", ");

    const warning = document.createElement("div");
    warning.id = PROBO_DATE_GUARD.warningId;
    warning.setAttribute("role", "alert");

    warning.style.cssText = [
      "background:#fff7ed",
      "border:1px solid #f59e0b",
      "color:#1f2937",
      "padding:16px",
      "margin:16px 0",
      "border-radius:8px",
      "font-size:15px",
      "line-height:1.45",
      "font-weight:500"
    ].join(";");

    warning.innerHTML = `
      <strong>Versandtermin nicht mehr verfügbar.</strong><br>
      ${PROBO_DATE_GUARD.message}
      ${productNames ? `<br><br><strong>Betroffener Artikel:</strong> ${productNames}` : ""}
    `;

    const target =
      document.querySelector("form[action*='/cart']") ||
      document.querySelector("cart-drawer") ||
      document.querySelector("main") ||
      document.body;

    target.prepend(warning);

    try {
      warning.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }

  async function validateProboCartBeforeCheckout() {
    const cart = await fetchCart();
    const invalidItems = getInvalidProboItems(cart);

    if (invalidItems.length > 0) {
      showWarning(invalidItems);
      return false;
    }

    return true;
  }

  let isChecking = false;

  async function handleCheckoutAttempt(event) {
    if (isChecking) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    isChecking = true;

    try {
      const isValid = await validateProboCartBeforeCheckout();

      if (isValid) {
        window.location.href = `${getShopRoot()}checkout`;
      }
    } catch (error) {
      console.error("Versandtermin-Prüfung fehlgeschlagen:", error);

      alert(
        "Der Warenkorb konnte gerade nicht geprüft werden. Bitte versuchen Sie es erneut."
      );
    } finally {
      isChecking = false;
    }
  }

  /*
    Klicks auf Checkout-Buttons / Checkout-Links abfangen.
    Funktioniert für Warenkorbseite und viele Cart-Drawer-Buttons.
  */
  document.addEventListener(
    "click",
    function (event) {
      const checkoutElement = event.target.closest(
        "a[href*='/checkout'], button[name='checkout'], input[name='checkout']"
      );

      if (!checkoutElement) return;

      handleCheckoutAttempt(event);
    },
    true
  );

  /*
    Falls der Checkout über ein Formular abgeschickt wird.
  */
  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute("action") || "";
      const submitter = event.submitter;

      const isCheckoutForm =
        action.includes("/checkout") ||
        (action.includes("/cart") &&
          submitter &&
          submitter.getAttribute("name") === "checkout");

      if (!isCheckoutForm) return;

      handleCheckoutAttempt(event);
    },
    true
  );
})();